import { Component, OnInit, Input } from '@angular/core';

import { ProjectService } from '@sparro/api/project/project.service'

import { Content } from '@sparro/app/core/models/project.model';
import { UNI_CONSTANTS } from '@sparro/core/config/constants.config';

@Component({
	selector: 'uni-project-panel',
	templateUrl: './project-panel.component.html',
	styleUrls: ['./project-panel.component.scss']
})
export class ProjectPanelComponent implements OnInit {
	@Input() slug: string;
	@Input() uuid: string;
	@Input() host: string;

	content: Content;
	loading: boolean = false;

	constructor(
		private projectService: ProjectService,
	) { }

	ngOnInit() {
		this.loading = true;
		if (!this.uuid) {
			this.uuid = 'latest';
		}
		this.getProjectContent()
	}

	getProjectContent() {
		this.projectService.getProjectVersion(this.slug, this.uuid).subscribe(
			(response: any) => {
				this.content = response;
				if(this.host === UNI_CONSTANTS.HOSTS.PROJECT && this.content.medias && this.content.medias.length > 0) {
					this.content.medias.splice(0, 1);
				}
				this.loading = false;
			},
			(err) => {
				console.log(err);
				this.loading = false;
			});
	}

}
